import { inject, Injectable } from '@angular/core';
import { ConfigurationManagerService, EntityManagerService } from 'src/app/core';
import { Sales } from 'tilby-models';
import { SaleDataSentStatus } from '../models/history.module';
import { MassiveSendPreferencesSatus } from '../history-sales-data-sent/history-sales-data-sent.model';

@Injectable({
  providedIn: 'root'
})
export class HistoryDataOperationsService {

  private entityManagerService = inject(EntityManagerService);
  private readonly configurationManager = inject(ConfigurationManagerService);

  async loadSalesDataSentList() {
    const endDate = new Date();
    const startDate = new Date();
    startDate.setMonth(startDate.getMonth() - 4);

    const saleDataSentList = await this.entityManagerService.salesDataSent.fetchCollectionOnline(
      { closed_at_since: startDate.toISOString(), closed_at_max: endDate.toISOString(), entity: 'zpms' }) as Sales[];

    return saleDataSentList;
  }


  getSaleDataSentStatus(item: any, prefStatus?: MassiveSendPreferencesSatus): SaleDataSentStatus {
    const { isLockActive, sale_ids } = prefStatus || this.getMassiveSentPreferences();

    if (isLockActive && sale_ids.includes(Number(item.id))) {
      return 'pending';
    }

    const lastSend = item.sale_data_sent?.[0];
    if (!lastSend) return 'manage';

    const realStatus = lastSend.status;
    if (realStatus === 'closed') return 'closed';

    const retry = lastSend.retry || 0;

    if (realStatus === 'pending' || (realStatus === 'failed' && retry < 3)) {
      return 'pending';
    }

    return realStatus;
  }

  getMassiveSentPreferences() {
    const limitSeconds = Number(this.configurationManager.getShopPreference('history.sales_data_sent.massive_send_time_limit') || 0);
    const prefState = this.configurationManager.getShopPreference('history.sales_data_sent.massive_send_state');

    let isLockActive = false;
    let sale_ids = [];

    if (prefState) {
      const prefStateObj = JSON.parse(prefState);
      const diffSeconds = (Date.now() - new Date(prefStateObj.updated_at).getTime()) / 1000;
      isLockActive = diffSeconds < limitSeconds;
      sale_ids = prefStateObj.sale_ids;
    }

    return {isLockActive, sale_ids}
  }
}
